import { styled } from "@mui/material";
import { Button } from "components";
import ChatbotIcon from "./ChatbotIcon";

const ContainerStyled = styled("div")(({ theme }) => ({
  width: "max-content",
  "& .chatbot-button": {
    height: "60px",
    width: "30px",
    borderRadius: "10px",
    backgroundColor: theme.navbarColors.background,
    "&:hover": { backgroundColor: "#223E45" },
  },
}));

const ChatbotFloatingButtonUnstyled = ({ onClick, className, children }) => {
  return (
    <ContainerStyled className={className}>
      <Button className="chatbot-button" variant="filled" onClick={onClick}>
        <ChatbotIcon fontSize="large" sx={{ color: "#2AC5EC" }} />
      </Button>
      {children}
    </ContainerStyled>
  );
};

const ChatbotFloatingButton = styled(ChatbotFloatingButtonUnstyled)({});

export default ChatbotFloatingButton;
